const initializedContainers = new WeakSet();

const initImpactBuilding = (scope = document) => {
  const containers = scope.matches?.('.impact-building-container')
    ? [scope]
    : scope.querySelectorAll('.impact-building-container');

  containers.forEach((container) => {
    if (initializedContainers.has(container)) {
      return;
    }

    const bg = container.querySelector('.impact-building-container__bg');
    const buildingSection = container.querySelector('.building-sec');

    if (!bg || !buildingSection) {
      return;
    }

    initializedContainers.add(container);

    let resizeFrame = null;

    const updateBgOffset = () => {
      const containerTop = container.getBoundingClientRect().top;
      const buildingTop = buildingSection.getBoundingClientRect().top;
      const offset = Math.max(0, buildingTop - containerTop);

      bg.style.setProperty('--building-sec-top-offset', `${offset}px`);
      bg.style.opacity = '1';
    };

    const throttledUpdateBgOffset = () => {
      if (resizeFrame) {
        return;
      }

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = null;
        updateBgOffset();
      });
    };

    throttledUpdateBgOffset();
    window.setTimeout(throttledUpdateBgOffset, 200);
    window.setTimeout(throttledUpdateBgOffset, 1000);
    window.addEventListener('resize', throttledUpdateBgOffset, { passive: true });
  });
};

initImpactBuilding();
window.initImpactBuilding = initImpactBuilding;
